import {
  Box,
  lighten,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import CircleIcon from '@mui/icons-material/Circle';
// eslint-disable-next-line no-use-before-define
import React, { FC } from 'react';
import { CriteriaData, Field } from '@models/CriteriaData';
import Router, { useRouter } from 'next/router';
import { rewriteRouteWithNewCriteria } from '../../../../shared/functions';

interface CustomTooltipProps {
  title: string;
  icon?: string;
  data: {
    id: string;
    label: string;
    value: number;
    color?: string;
    total?: number;
    entities?: { name: string; docCount: number }[];
  };
  filterQuery?: Field;
}

export const CustomTooltip: FC<CustomTooltipProps> = ({
  title,
  data,
  icon = 'material-symbols:data-object',
  filterQuery,
}) => {
  const router = useRouter();

  const getFullTitle = (title: string, entitiesLength: number | undefined) => {
    if (entitiesLength && entitiesLength > 0) {
      return `Top ${data?.entities?.length} ${title}`;
    }

    return title;
  };

  return (
    <>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{
          backgroundColor: 'rgba(0,0,0,0.5)',
          py: 1,
          px: 1,
          mb: 0.5,
        }}
      >
        <Typography>{getFullTitle(title, data?.entities?.length)}</Typography>
        <Icon icon={icon} fontSize={25} />
      </Stack>
      <Stack spacing={1} direction={'row'} alignItems={'center'}>
        <Box sx={{ width: 15, height: 15, backgroundColor: data.color }} />
        <Stack direction={'row'} spacing={1}>
          <Typography variant="body2">{`${data?.label}`}</Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bolder',
              color: lighten(data?.color, 0.65),
            }}
          >{`(${Math.floor((data?.value / data.total) * 100)}%)`}</Typography>
        </Stack>
      </Stack>
      <List sx={{ maxHeight: 350, overflow: 'auto' }}>
        {/* @ts-ignore */}
        {data?.entities?.map((entity) => (
          <ListItemButton
            key={entity.name}
            onClick={() => {
              if (filterQuery) {
                rewriteRouteWithNewCriteria(Router, {
                  q: entity.name,
                  field: filterQuery,
                  operator: 'AND',
                  accuracy: 'Vague',
                });
              }
            }}
          >
            <CircleIcon style={{ fontSize: 10, marginRight: 8 }} />
            <ListItemText>{entity.name}</ListItemText>
          </ListItemButton>
        ))}
      </List>
    </>
  );
};
